/* Judaluxe · utilidades mayoristas (escalas, combos, armá tu combo) */
(function () {
  if (window.JLM) return;
  var TIERS = [{ q: 20, p: 10 }, { q: 10, p: 7 }, { q: 5, p: 5 }];
  var MIN = 200000;

  function money(c) {
    return '$' + Math.round(c / 100).toLocaleString('es-UY');
  }
  function tierFor(units) {
    for (var i = 0; i < TIERS.length; i++) if (units >= TIERS[i].q) return TIERS[i];
    return null;
  }
  function nextTier(units) {
    for (var i = TIERS.length - 1; i >= 0; i--) if (units < TIERS[i].q) return TIERS[i];
    return null;
  }

  function toast(msg, ok) {
    var t = document.querySelector('.jlm-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'jlm-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = msg + (ok ? ' <a href="/cart">Ver carrito →</a>' : '');
    t.classList.toggle('is-error', !ok);
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 4500);
  }

  /* Actualiza y abre el cajón del carrito (o recarga la página de carrito). */
  function openCart() {
    if (/^\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return Promise.resolve(true); }
    var d = document.getElementById('cart-drawer');
    if (!d) return Promise.resolve(false);
    return fetch(window.location.pathname + '?sections=cart-drawer-section')
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j && j['cart-drawer-section'];
        if (!html) return false;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('.cart-drawer__inner'), cur = d.querySelector('.cart-drawer__inner');
        if (!fresh || !cur) return false;
        cur.replaceWith(fresh);
        if (typeof d.open === 'function') d.open();
        return true;
      })
      .catch(function () { return false; });
  }

  function add(items, btn, opts) {
    items = items.filter(function (i) { return i.quantity > 0; });
    if (!items.length) return Promise.resolve();
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'No se pudo agregar');
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'jl-mayorista', data: { itemCount: cart.item_count } } }));
        if (opts && opts.checkout) { window.location.href = '/checkout'; return; }
        return openCart().then(function (opened) {
          if (!opened) {
            var u = items.reduce(function (s, i) { return s + i.quantity; }, 0);
            toast('Agregaste ' + u + (u === 1 ? ' unidad' : ' unidades') + ' al carrito.', true);
          }
        });
      })
      .catch(function (e) { toast(e.message || 'No se pudo agregar', false); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = label; } });
  }

  /* Reparte qty entre variantes con stock, con colores al azar (respeta el stock de cada color). */
  function spread(variants, qty) {
    var units = [];
    variants.forEach(function (v) {
      if (!v.a || !(v.s > 0)) return;
      for (var k = 0; k < v.s && k < 500; k++) units.push(v.id);
    });
    for (var i = units.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = units[i]; units[i] = units[j]; units[j] = t;
    }
    var take = units.slice(0, qty), count = {};
    take.forEach(function (id) { count[id] = (count[id] || 0) + 1; });
    return { items: Object.keys(count).map(function (id) { return { id: Number(id), quantity: count[id] }; }), missing: Math.max(0, qty - take.length) };
  }

  window.JLM = { openCart: openCart, buyNow: function (items, btn) { return add(items, btn, { checkout: true }); }, money: money, tierFor: tierFor, nextTier: nextTier, add: add, spread: spread, toast: toast, TIERS: TIERS, MIN: MIN };
})();
